import { required, sameAs, minLength } from 'vuelidate/lib/validators';

export default {
  validations: {
    resetPasswordApi: {
      password: {
        required,
        minLength: minLength(8),
      },
      passwordConfirm: {
        required,
        sameAsPassword: sameAs('password'),
        minLength: minLength(8),
      },
    },
  },
};
